import { IconProps } from "@assets";

const NextElement = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg
            width={props.size ?? "60"}
            height={props.size ?? "60"}
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="30" cy="30" r="29" transform="rotate(180 30 30)" stroke="#D7E3F5" strokeWidth="2" />
            <path
                d="M27 22L35 29.9998L27 38"
                stroke="#D7E3F5"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default NextElement;
